import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ApiService } from "../../common/api.service";
import { ROUTES } from "../server-routes";

@Injectable({
  providedIn: 'root',
})
export class PhilMetaService extends ApiService {
  public getDepositTypes(form?: any): Observable<any> {
    return this.get<any>(
      ROUTES.GET_PHIL_DEPOSIT_CODES, {
      params: form ?? '',
    })

  }
  public addDepositTypes(paylaod: any): Observable<any> {
    return this.post<any>(
      ROUTES.GET_PHIL_DEPOSIT_CODES, {
      body: paylaod
    })

  }
  public updateMiscCode(paylaod: { id: number, status: string }): Observable<any> {
    return this.put<any>(
      ROUTES.UPDATE_PHIL_DEPOSIT_CODES, {
      body: paylaod,
    })

  }

  public getObjectSpecifications(): Observable<any> {
    return this.get<any>(ROUTES.GET_OBJECT_SPECIFICATION);
  }

  public getAllBanks(type: string): Observable<any> {
    return this.get<any>(ROUTES.GET_ALL_BANKS, {
      params: {
        t: type,
      },
    });
  }

  // public getUserInfo(paramObj: any): Observable<any> {
  //   return this.get<any>(ROUTES.USER_INFO, {
  //     params: paramObj
  //   });
  // }

  // public updateUserContact(payload: any): Observable<any> {
  //   return this.post<any>(ROUTES.UPDATE_USER_CONTACT, {
  //     body: payload
  //   });
  // }

  public getPaymentModes(): Observable<any> {
    return this.get<any>(
      this.replacePathInfo(ROUTES.GET_PAYMENT_MODES)
    );
  }

  public getAllStatusses(): Observable<any> {
    return this.get<any>(ROUTES.GET_ALL_STATUSSSES);
  }

  private subTotalSubject = new BehaviorSubject<string | null>(null);
  subTotal$ = this.subTotalSubject.asObservable();

  setSubTotal(code: string) {
    this.subTotalSubject.next(code);
  }

  public getApplicationConfig(key: string): Observable<any> {
    return this.get<any>(ROUTES.CONFIG, {
      params: { key }
    });
  }
}